// Filter function to get unique values from an array
export function onlyUnique(value: any, index: any, array: any[]): boolean {
  return array.indexOf(value) === index;
}
